import List from "@mui/material/List";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import getRoutingStore from "../../stores/routing";
import NavGroup from "./side-bar-menu/NavGroup";
import NavItem from "./side-bar-menu/NavItem";

// Khattaba-only sidebar: only the dropdowns/items a khattaba (matchmaker)
// admin uses are rendered. The User list themselves already hidden non-khattaba links.
// Non-khattaba zones (CSR / Auditor / Supervisor / Communications / QA  / Shareholder) have been removed.
const SideBarMenu = withLiteObserverAndTheme<{ onNavigate: () => void }>(
  (props) => {
    const { onNavigate } = props;
    const isManualKhattabaAdmin =
      getCorePersonalStore().isManualKhattabaAdmin.get();
    const pageName = getCoreHistoryStore().getPageName();

    const userOptions = getRoutingStore().getVisibleUserOptions();

    return (
      <List
        component="nav"
        aria-label={i18n.get("MAIN_NAVIGATION")}
        sx={{ px: 1.5, py: 1 }}
      >
        {isManualKhattabaAdmin ? (
          <NavGroup
            title={i18n.get("USER")}
            icon={<PersonOutlineOutlinedIcon />}
            isOpenObservable={getCoreUIStore().userDropdownIsOpen}
            hasSelectedChild={userOptions.some(({ isSelected }) => isSelected)}
          >
            {userOptions.map(({ option, isSelected }) => (
              <NavItem
                key={option.link}
                title={option.title}
                link={option.link}
                icon={null}
                isSelected={isSelected}
                isNested={true}
                onNavigate={onNavigate}
              />
            ))}
          </NavGroup>
        ) : null}

        {isManualKhattabaAdmin ? (
          <NavItem
            title={i18n.get("MATCHMAKING")}
            link="/khattabatMatching/searchAnd1O1M"
            icon={<FavoriteBorderOutlinedIcon />}
            isSelected={pageName === "KHATTABAT_MATCHING_SEARCH_AND_1O1M"}
            isNested={false}
            onNavigate={onNavigate}
          />
        ) : null}
      </List>
    );
  }
);
export default SideBarMenu;
